/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetResultDto } from './GetResultDto';
import {
    GetResultDtoFromJSON,
    GetResultDtoFromJSONTyped,
    GetResultDtoToJSON,
} from './GetResultDto';

/**
 * 
 * @export
 * @interface CreateUpdateResultsDto
 */
export interface CreateUpdateResultsDto {
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateResultsDto
     */
    timestamp?: Date | null;
    /**
     * 
     * @type {Array<GetResultDto>}
     * @memberof CreateUpdateResultsDto
     */
    results?: Array<GetResultDto> | null;
}

/**
 * Check if a given object implements the CreateUpdateResultsDto interface.
 */
export function instanceOfCreateUpdateResultsDto(value: object): value is CreateUpdateResultsDto {
    return true;
}

export function CreateUpdateResultsDtoFromJSON(json: any): CreateUpdateResultsDto {
    return CreateUpdateResultsDtoFromJSONTyped(json, false);
}

export function CreateUpdateResultsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateResultsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'timestamp': json['timestamp'] == null ? undefined : (new Date(json['timestamp'])),
        'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(GetResultDtoFromJSON)),
    };
}

export function CreateUpdateResultsDtoToJSON(value?: CreateUpdateResultsDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'timestamp': value['timestamp'] == null ? undefined : ((value['timestamp'] as any).toISOString()),
        'results': value['results'] == null ? undefined : ((value['results'] as Array<any>).map(GetResultDtoToJSON)),
    };
}

